import ActiveRecord from './active_record/base'

class QuizItem extends ActiveRecord {
	static tableName = 'quizItems'
}

export default QuizItem
